import { Fragment } from "react/jsx-runtime"

const replace = [',']

export default function formatMediumFont(str: string, spanClass?: string) {
    return str.split('').map((i, index) => replace.includes(i) ? <span key={index} className={`!font-manrope ${spanClass ? spanClass : ''}`}>{i}</span> : <Fragment key={index}>{i}</Fragment>)
}